import type { IntegrationRouter } from "replo-publisher/src/trpc/routers/integration";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: integrationRouter,
  client: integrationClient,
  utils: integrationUtils,
  options: integrationOptions,
} = createTrpcRouterConfig<IntegrationRouter>({
  path: "integration",
  queryClient: getNamespacedQueryClient("integration"),
});

export {
  integrationClient,
  integrationRouter,
  integrationUtils,
  integrationOptions,
};
